import React, { Suspense } from 'react';
import { HeadingSkeleton } from './Heading';
import { Subcollections } from './Subcollections';
import { templateSuffix } from '../../configs';
import { FeaturedCollectionSkeleton } from './FeaturedCollections';
import { Breadcrumbs } from './Breadcrumbs';
import { ArtistBannerSkeleton } from './ArtistBanner';
import { FeaturedProductsSkeleton } from './FeaturedProducts';
import { MainBannerSkeleton } from './MainBanner/MainBanner.skeleton';
import { useDynamicConfigs } from '../../hooks/useDynamicConfigs';
import { useParams } from 'react-router-dom';
import FilterByTypeSkeleton from './FilterByType/FilterByType.skeleton';
const MainBanner = React.lazy(async () => await import('./MainBanner/MainBanner'));
const Heading = React.lazy(async () => await import('./Heading/Heading'));
const FeaturedCollections = React.lazy(async () => await import('./FeaturedCollections/FeaturedCollections'));
const FeaturedProducts = React.lazy(async () => await import('./FeaturedProducts/FeaturedProducts'));
const InternalLinks = React.lazy(async () => await import('./InternalLinks/InternalLinks'));
const ArtistBanner = React.lazy(async () => await import('./ArtistBanner/ArtistBanner'));
const FilterByType = React.lazy(async () => await import('./FilterByType/FilterByType'));
export const Header = () => {
    const { supplementaryData, hierarchyFacetKey } = useDynamicConfigs();
    const { handle } = useParams();
    if (templateSuffix === 'artist') {
        return (React.createElement(Suspense, { fallback: React.createElement(ArtistBannerSkeleton, null) },
            React.createElement(ArtistBanner, null)));
    }
    return (React.createElement("div", { "data-cy-test": 'CollectionHeader' },
        React.createElement(Breadcrumbs, null),
        supplementaryData?.mainBanner !== undefined
            ? React.createElement(Suspense, { fallback: React.createElement(MainBannerSkeleton, { imgHeight: supplementaryData.mainBanner.height, imgWidth: supplementaryData.mainBanner.width }) },
                React.createElement(MainBanner, { img: supplementaryData.mainBanner }))
            : React.createElement(Suspense, { fallback: React.createElement(HeadingSkeleton, null) },
                React.createElement(Heading, null)),
        (templateSuffix === 'shapes' ||
            templateSuffix === 'pieces' ||
            templateSuffix === 'mediums') &&
            React.createElement(Suspense, null,
                React.createElement(InternalLinks, null)),
        supplementaryData?.featuredCollections !== undefined &&
            React.createElement(Suspense, { fallback: React.createElement(FeaturedCollectionSkeleton, null) },
                React.createElement(FeaturedCollections, null)),
        supplementaryData?.featuredProducts !== undefined &&
            React.createElement(Suspense, { fallback: React.createElement(FeaturedProductsSkeleton, null) },
                React.createElement(FeaturedProducts, null)),
        hierarchyFacetKey !== undefined &&
            hierarchyFacetKey.length > 0 &&
            React.createElement(Subcollections, null),
        handle === 'photo-prints' &&
            React.createElement(Suspense, { fallback: React.createElement(FilterByTypeSkeleton, null) },
                React.createElement(FilterByType, null))));
};
